import { FC } from 'react';
import { Flex, Heading, Button } from '@chakra-ui/react';
import { ModalType } from 'components/modals/types';
import { VscLink } from 'react-icons/vsc';
import { useModal } from 'store/modals';

type Props = {
  headingText: string;
};

export const ConnectWallet: FC<Props> = ({ headingText }) => {
  const { openModal } = useModal();
  return (
    <Flex justifyContent='center' alignItems='center' py={10} flexDir='column'>
      <Heading size='lg' textAlign='center' mb={4}>
        {headingText}
      </Heading>
      <Button
        size='lg'
        rightIcon={<VscLink />}
        onClick={() => openModal(ModalType.connectWallet)}
      >
        Connect Wallet
      </Button>
    </Flex>
  );
};
